import styled from 'styled-components';

export const StyledSearchInput = styled.div`
  .search-input {
    width: 100%;
  }

  .MuiOutlinedInput-root {
    height: ${(props) => props?.styleInput?.height || '40px'};
    padding-left: ${(props) => props?.styleInput?.paddingLeft || '0px'};
    border-radius: ${(props) => props?.styleInput?.borderRadius || '8px'};
  }

  .MuiOutlinedInput-input {
    &::placeholder {
      font-size: ${(props) => props?.placeholderStyle?.fontSize || '14px'};
      font-weight: ${(props) =>
        props?.placeholderStyle?.fontWeight || 'normal'};
      color: ${(props) => props?.placeholderStyle?.color || 'inherit'};
    }

    &::-webkit-input-placeholder {
      font-size: ${(props) => props?.placeholderStyle?.fontSize || '14px'};
      font-weight: ${(props) =>
        props?.placeholderStyle?.fontWeight || 'normal'};
      color: ${(props) => props?.placeholderStyle?.color || 'inherit'};
    }

    &::-moz-placeholder {
      font-size: ${(props) => props?.placeholderStyle?.fontSize || '14px'};
      font-weight: ${(props) =>
        props?.placeholderStyle?.fontWeight || 'normal'};
      color: ${(props) => props?.placeholderStyle?.color || 'inherit'};
    }

    &:-ms-input-placeholder {
      font-size: ${(props) => props?.placeholderStyle?.fontSize || '14px'};
      font-weight: ${(props) =>
        props?.placeholderStyle?.fontWeight || 'normal'};
      color: ${(props) => props?.placeholderStyle?.color || 'inherit'};
    }
  }
`;
